import { useEffect } from 'react';

import { useNavigate, useSearchParams } from 'react-router-dom';

import { useQueryClient } from '@tanstack/react-query';
import { BsCheckCircle } from 'react-icons/bs';

import Card from '#globalComponents/Card/Card';
import Page from '#globalComponents/Page/Page';
import FullscreenLayout from '#layouts/FullscreenLayout';

import { postMailingCampaignsKeys } from '../../models/campaigns/keys';

/**
 * Landing page after a successful Stripe Checkout for a post-mailing payment. The actual send is released
 * by the backend webhook (immediately for card/PayPal, after clearing for SEPA), so here we just refresh
 * the campaign data and forward the user to the campaign detail page, which shows the live payment/send
 * status + timeline.
 */
export const PostMailingCheckoutSuccessPage = () => {
	const navigate = useNavigate();
	const queryClient = useQueryClient();
	const [searchParams] = useSearchParams();
	const campaignId = searchParams.get('campaignId');

	useEffect(() => {
		if (campaignId) {
			queryClient.invalidateQueries({ queryKey: postMailingCampaignsKeys.detail(campaignId) });
			queryClient.invalidateQueries({ queryKey: postMailingCampaignsKeys.list() });
		}
		const timer = setTimeout(() => {
			navigate(campaignId ? `/post-mailing/${campaignId}` : '/post-mailing', { replace: true });
		}, 2500);
		return () => clearTimeout(timer);
	}, [campaignId, navigate, queryClient]);

	return (
		<Page>
			<FullscreenLayout backdrop="success">
				<Card className="p-12 text-center">
					<div className="mx-auto mb-6 flex h-20 w-20 items-center justify-center rounded-full bg-success-200">
						<BsCheckCircle size={48} className="text-success-700" />
					</div>
					<h1 className="mb-3 text-lg font-bold text-text">Zahlung erhalten</h1>
					<p className="text-text">
						Vielen Dank! Wir bereiten Ihren Versand vor. Sie werden gleich zur Kampagne weitergeleitet …
					</p>
				</Card>
			</FullscreenLayout>
		</Page>
	);
};
